/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
	GET_PUSH_EVENTS_FAILURE,
	GET_PUSH_EVENTS_REQUEST,
	GET_PUSH_EVENTS_SUCCESS,
	GetPushEventsFailureAction,
	GetPushEventsRequestAction,
	GetPushEventsSuccessAction,
	PushEventActionTypes
} from './PushEventActionTypes';
import { initialPushEventState, PushEventState } from './PushEvent.state';

const getPushEventsRequest = (state: PushEventState, action: GetPushEventsRequestAction): PushEventState => {
	return {
		...state,
		list: {
			...state.list,
			loading: true,
			error: null
		}
	};
};

const getPushEventsSuccess = (state: PushEventState, action: GetPushEventsSuccessAction): PushEventState => {
	return {
		...state,
		list: {
			...state.list,
			loading: false,
			pushEvents: action.pushEvents
		}
	};
};

const getPushEventsFailure = (state: PushEventState, action: GetPushEventsFailureAction): PushEventState => {
	return {
		...state,
		list: {
			...state.list,
			loading: false,
			error: action.error
		}
	};
};

const reducer = (state = initialPushEventState, action: PushEventActionTypes): PushEventState => {
	switch (action.type) {
		case GET_PUSH_EVENTS_REQUEST:
			return getPushEventsRequest(state, action);
		case GET_PUSH_EVENTS_SUCCESS:
			return getPushEventsSuccess(state, action);
		case GET_PUSH_EVENTS_FAILURE:
			return getPushEventsFailure(state, action);
		default:
			return state;
	}
};

export default reducer;
